// env
export const env = process.env.REACT_APP_ENV

// server
export const baseUrl = process.env.REACT_APP_BASE_URL
export const baseApiUrl = process.env.REACT_APP_BASE_API_URL

// auth
export const basicAuthUsername = 'inspector'
export const basicAuthPassword = '9bM87tVn5S6+otX9d1v'

// payment
export const gPayGateway = process.env.REACT_APP_GPAY_GATEWAY
export const gPayGatewayMerchantId = process.env.REACT_APP_GPAY_GATEWAY_MERCHANT_ID
export const gPayMerchantId = process.env.REACT_APP_GPAY_MERCHANT_ID
export const gPayMerchantName = process.env.REACT_APP_GPAY_MERCHANT_NAME
